'use strict';

/* eslint-env browser */

module.exports = async function fetchJSONBrowser(url) {
    const result = await fetch(url);
    return result.json();
};



// WEBPACK FOOTER //
// ./packages/emdb/src/util/fetchJSONBrowser.js